// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://192.168.88.121:4080/api',
  // serverUrl: 'http://192.168.88.121:4080',
  apiUrl: 'https://smartrack-alia.seetrack.it:4083/api',
  serverUrl: 'https://smartrack-alia.seetrack.it:4083',
  webSocketPath: '/ws/session',
  webSocketPort: 4181,
  custom: {
    url: 'http://localhost:4090',
    system: 'smartrack',
    apiKey: 'dcofwqejgx822cf7w7ucs8myn3x0a6e2qqiucunhcqzg2nd35z85yls7xur4a0db'
  }
};

export const environment_devenv = {
  production: false,
  // apiUrl: 'http://192.168.88.121:4080/api',
  // serverUrl: 'http://192.168.88.121:4080',
  apiUrl: 'http://10.0.8.5:4080/api',
  serverUrl: 'http://10.0.8.5:4080',
  webSocketPath: '/ws/session',
  webSocketPort: 4181,
  custom: {
    url: 'http://localhost:4090',
    system: 'smartrack',
    apiKey: 'dcofwqejgx822cf7w7ucs8myn3x0a6e2qqiucunhcqzg2nd35z85yls7xur4a0db'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
